import { CellContext } from '@tanstack/react-table';

import { isoDateFromTimestamp } from '@/portainer/filters/filters';
import { useUser, UserNotFoundError } from '@/portainer/users/queries/useUser';

import { EdgeConfiguration } from '../../types';

import { columnHelper } from './helper';

export const created = columnHelper.accessor('created', {
  id: 'created',
  header: 'Created',
  cell: Cell,
});

function Cell({
  getValue,
  row: {
    original: { createdBy },
  },
}: CellContext<EdgeConfiguration, EdgeConfiguration['created']>) {
  const value = getValue();
  const { data, error } = useUser(createdBy, { silent: true });

  let content = isoDateFromTimestamp(value);
  if (data) {
    content += ` by ${data.Username}`;
  } else if (error instanceof UserNotFoundError) {
    content += ' by (deleted user)';
  }

  return <span>{content}</span>;
}
